import React                    from 'react';
import { Observe }              from 'rewire-core';
import {
  WithStyle,
  FormView
}                               from 'rewire-ui';
import { Theme }                from '@material-ui/core/styles';
import DraggableResizableDialog from '../ui/DraggableResizableDialog';
import duplicateAreaDialogModel from './DuplicateAreaDialogModel';
import { withStyles }           from '../utility/styles';

const styles = (_theme: Theme) => ({
});

interface IDuplicateAreaDialogProps {
}

type DuplicateAreaDialogProps = WithStyle<ReturnType<typeof styles>, IDuplicateAreaDialogProps>;

class DuplicateAreaDialog extends React.PureComponent<DuplicateAreaDialogProps> {
  constructor(props: DuplicateAreaDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    duplicateAreaDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={duplicateAreaDialogModel.form} onSubmit={duplicateAreaDialogModel.actionFn('save')}>
        <div className='content'>
          <duplicateAreaDialogModel.form.field.name.Editor className='span1' />
        </div>
        <div className='content'>
          <duplicateAreaDialogModel.form.field.startDate.Editor className='span1' />
          <duplicateAreaDialogModel.form.field.endDate.Editor className='span1' />
        </div>
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: duplicateAreaDialogModel}} DraggableResizableBoxProps={{minWidth: '270px', minHeight: '285px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IDuplicateAreaDialogProps>(styles, DuplicateAreaDialog);
